import { render, staticRenderFns } from "./highlightFilter.vue?vue&type=template&id=5ba20743&scoped=true"
import script from "./highlightFilter.vue?vue&type=script&lang=js"
export * from "./highlightFilter.vue?vue&type=script&lang=js"
import style0 from "./highlightFilter.vue?vue&type=style&index=0&id=5ba20743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba20743",
  null
  
)

export default component.exports